import { Controller } from "stimulus";
import { EventGeckoChartRendered } from "../../events";

export default class extends Controller {
  static targets = ["chart"];

  chartInstance = null;
  chartUrls = null;
  selectedRange = null;

  connect() {
    window.addEventListener(EventGeckoChartRendered, this.onChartRerender.bind(this));

    this.chartUrls = JSON.parse(this.element.dataset.chartUrls);
    this.selectedRange = this.chartTarget.dataset.selectedRange;
  }

  handleOptionChange(e) {
    const optionKey = e.currentTarget.dataset.key;

    // If the option is already selected, do nothing.
    if (this.selectedRange === optionKey) {
      return;
    }

    e.currentTarget.classList.add("selected");

    this.selectedRange = optionKey;
    this.refreshChartSettings();
  }

  refreshChartSettings() {
    this.chartTarget.dataset.dataUrl = this.chartUrls?.[this.selectedRange];
    this.chartTarget.dataset.tokenomicFinancialsChartBuildingRerenderValue = true;
  }

  onChartRerender(e) {
    this.chartInstance = e.detail.chart;
  }
}
